function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsEmail = function SvgSettingsEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 50,
    height: 50,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0"
    },
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.659-9.042c-.787.612-1.828 1.392-5.414 4-.714.517-1.99 1.681-3.245 1.671-1.248.007-2.5-1.129-3.241-1.674-3.586-2.605-4.631-3.382-5.418-3.994A.21.21 0 0 0-9-8.873v7.186A1.688 1.688 0 0 0-7.313 0H7.312A1.688 1.688 0 0 0 9-1.687v-7.19a.212.212 0 0 0-.341-.165ZM0-4.5c.816.014 1.99-1.027 2.58-1.455 4.665-3.386 5.02-3.681 6.1-4.525a.841.841 0 0 0 .32-.665v-.668A1.688 1.688 0 0 0 7.312-13.5H-7.313A1.688 1.688 0 0 0-9-11.812v.668a.846.846 0 0 0 .323.664c1.076.84 1.431 1.139 6.1 4.525C-1.99-5.527-.816-4.486 0-4.5Z",
    transform: "translate(25 31.5)",
    style: {
      fill: "#666"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-email.66cc74c8.svg";
export { ForwardRef as ReactComponent };